import {
	APPLICATION_TYPE_AMENDMENT,
	APPLICATION_TYPE_REGISTRATION,
	APPLICATION_TYPE_MIGRATION,
	APPLICATION_TYPE_REINSTATEMENT,
	APPLICATION_TYPE_REMOVAL,
	APPLICATION_TYPE_SUSPENSION,
	APPLICATION_TYPE_TRANSFER,
	APPLICATION_TYPE_OBJECTION,
	APPLICATION_TYPE_CORRECTION
} from "./constants";
import { Adjudication } from "./pages/Adjudication";
import { AdministrationReports } from "./pages/AdministrationReports";
import { Applications } from "./pages/applications/Applications";
import { ApplicationSearch } from "./pages/applications/Search";
import { CandidateReports } from "./pages/CandidateReports";
import { Dashboard } from "./pages/dashboard/Dashboard";
import { DelimitationManagement } from "./pages/DelimitationManagement";
import { EventGroup } from "./pages/EventGroup";
import { Events } from "./pages/Events";
import { EventElectionRegister } from "./pages/EventElectionRegister";
import { KitConfiguration } from "./pages/KitConfiguration";
import { MohaFile } from "./pages/MohaFile";
import { Objections } from "./pages/Objections";
import { PoliticalPartyManagement } from "./pages/politicalParty/PoliticalPartyManagement";
import { PoliticalPartyReports } from "./pages/PoliticalPartyReports";
import PoliticalPartyUsers from "./pages/PoliticalPartyUsers";
import { Reports } from "./pages/reports/Reports";
import { SystemParameters } from "./pages/SystemParameters";
import { Users } from "./pages/Users";
import { UserGroups } from "./pages/groups/UserGroups";
import VoterAllocationParams from "./pages/VoterAllocationParams";
import { VoterAuditHistory } from "./pages/VoterAuditHistory";
import { VoterAuditSearch } from "./pages/voters/VoterAuditSearch";
import { CandidateManagement } from "./pages/CandidateManagement/CandidateManagement";
import ContestationPeriods from "./pages/ContestationPeriods/ContestationPeriods";

export const menu = [
	{
		label: "Home",
		items: [
			{
				label: "Dashboard",
				icon: "pi pi-fw pi-home",
				to: "/"
			},
			{
				label: "Administration",
				icon: "pi pi-fw pi-folder-open",
				items: [
					{
						label: "Device Management",
						icon: "pi pi-fw pi-bookmark",
						to: "/administration/devices"
					},
					{
						label: "MOHA File",
						icon: "pi pi-fw pi-bookmark",
						to: "/administration/mohafile"
					},
					{
						label: "Voter Allocation Params",
						icon: "pi pi-fw pi-bookmark",
						to: "/voter-allocation-params"
					},
					{
						label: "User Management",
						icon: "pi pi-fw pi-user-edit",
						items: [
							{
								label: "Users",
								icon: "pi pi-fw pi-bookmark",
								to: "/user-management/users"
							},
							{
								label: "Groups",
								icon: "pi pi-fw pi-bookmark",
								to: "/user-management/groups"
							},
							{
								label: "Political Party Users",
								icon: "pi pi-fw pi-bookmark",
								to: "/user-management/political-party-users"
							}
						]
					},
					{
						label: "System Parameters",
						icon: "pi pi-fw pi-cog",
						to: "/system-parameters"
					},
					{
						label: "Constituency / Electoral Division  Management",
						icon: "pi pi-fw pi-bookmark",
						to: "/administration/delimitation-management"
					}
				]
			},
			{
				label: "Elector Management",
				icon: "pi pi-fw pi-database",
				items: [
					{
						label: "Applications",
						icon: "pi pi-fw pi-database",
						items: [
							{
								label: "Search",
								icon: "pi pi-fw pi-search",
								to: "/applications/search"
							},
							{
								label: "Amendments",
								icon: "pi pi-fw pi-bookmark",
								to: "/applications/amendments"
							},
							{
								label: "Re-Instatements",
								icon: "pi pi-fw pi-bookmark",
								to: "/applications/reinstatements"
							},
							{
								label: "Registrations",
								icon: "pi pi-fw pi-bookmark",
								to: "/applications/registrations"
							},
							{
								label: "Migrations",
								icon: "pi pi-fw pi-bookmark",
								to: "/applications/migrations"
							},
							{
								label: "Removals",
								icon: "pi pi-fw pi-bookmark",
								to: "/applications/removals"
							},
							{
								label: "Suspensions",
								icon: "pi pi-fw pi-bookmark",
								to: "/applications/suspensions"
							},
							{
								label: "Transfers",
								icon: "pi pi-fw pi-bookmark",
								to: "/applications/transfers"
							},
							,
							{
								label: "Corrections",
								icon: "pi pi-fw pi-bookmark",
								to: "/applications/corrections"
							},

							{
								label: "Self Service Checks",
								icon: "pi pi-fw pi-bookmark",
								items: [
									{
										label: "Amendments",
										icon: "pi pi-fw pi-bookmark",
										to: "/applications/unassisted/amendments"
									},
									{
										label: "Registrations",
										icon: "pi pi-fw pi-bookmark",
										to: "/applications/unassisted/registrations"
									}
								]
							}
						]
					},
					{
						label: "Elector History",
						icon: "pi pi-fw pi-database",
						items: [
							// {
							//     label: "Elector Data",
							//     icon: "pi pi-fw pi-bookmark",
							//     to: "/voter-data",
							// },
							{
								label: "Elector Search",
								icon: "pi pi-fw pi-search",
								to: "/voters/search"
							}
						]
					}
				]
			},
			{
				label: "Objection Management",
				icon: "pi pi-fw pi-database",
				items: [
					{
						label: "Objections",
						icon: "pi pi-fw pi-bookmark",
						to: "/objections"
					},
					{
						label: "Adjudication",
						icon: "pi pi-fw pi-bookmark",
						to: "/adjudication"
					}
				]
			},
			{
				label: "Nomination of Candidates",
				icon: "pi pi-fw pi-users",
				items: [
					{
						label: "Candidates",
						icon: "pi pi-fw pi-bookmark",
						to: "/candidate-management"
					},
					{
						label: "Ballot Paper Proof",
						icon: "pi pi-fw pi-bookmark",
						to: "/reports/candidatBallot"
					}
				]
			},
			{
				label: "Political Party Management",
				icon: "pi pi-fw pi-users",
				items: [
					{
						label: "Political Parties",
						icon: "pi pi-fw pi-bookmark",
						to: "/political-party-management"
					},
					{
						label: "Membership Periods",
						icon: "pi pi-fw pi-bookmark",
						to: "/membership-periods"
					},
					{
						label: "Report",
						icon: "pi pi-fw pi-bookmark",
						to: "/reports/politicalBallot"
					}
				]
			},
			{
				label: "Event Management",
				icon: "pi pi-fw pi-clone",
				items: [
					{
						label: "Event Groups",
						icon: "pi pi-fw pi-bookmark",
						to: "/event-management/event-groups"
					}
				]
			},
			{
				label: "Elector Register",
				icon: "pi pi-fw pi-clone",
				items: [
					{
						label: "Register",
						icon: "pi pi-fw pi-bookmark",
						to: "/event-register-management/register"
					}
				]
			},
			{
				label: "Reports",
				icon: "pi pi-fw pi-clone",
				items: [
					{
						label: "Application",
						icon: "pi pi-fw pi-bookmark",
						to: "/reports/applications"
					},
					{
						label: "Elector",
						icon: "pi pi-fw pi-bookmark",
						to: "/reports/elector"
					},
					{
						label: "Age Group",
						icon: "pi pi-fw pi-bookmark",
						to: "/reports/agegroup"
					},
					{
						label: "MOHA",
						icon: "pi pi-fw pi-bookmark",
						to: "/reports/moha"
					},
					{
						label: "MOHA Request",
						icon: "pi pi-fw pi-bookmark",
						to: "/reports/moha_request"
					},
					{
						label: "Elector Register",
						icon: "pi pi-fw pi-bookmark",
						to: "/reports/register"
					}
					// {
					// 	label: "Ballot",
					// 	icon: "pi pi-fw pi-bookmark",
					// 	to: "/reports/ballot"
					// }
				]
			}
		]
	}
];

export function CentalSiteGenerateRoutesAndMenu(azureLoginState) {
	var routes = {
		"/": { component: Dashboard },
		"/user-management/users": { component: Users },
		"/user-management/groups": { component: UserGroups },
		"/user-management/political-party-users": { component: PoliticalPartyUsers },
		"/administration/devices": { component: KitConfiguration },
		"/administration/mohafile": { component: MohaFile },
		"/voter-allocation-params": { component: VoterAllocationParams },
		"/system-parameters": { component: SystemParameters },
		"/administration/delimitation-management": { component: DelimitationManagement },
		"/voter-audit-history": { component: VoterAuditHistory },
		"/objections": {
			component: ({ applicationTypeID, channelCategoryID }) => {
				return (
					<>
						<Applications RenderObjection={<Objections />} applicationTypeID={applicationTypeID} channelCategoryID={channelCategoryID} />
					</>
				);
			},
			applicationTypeID: APPLICATION_TYPE_OBJECTION,
			screenType: "Objections"
		},
		"/political-party-management": { component: PoliticalPartyManagement },
		"/political-party-reports": { component: PoliticalPartyReports },
		"/candidate-management": { component: CandidateManagement },

		"/candidate-reports": { component: CandidateReports },
		"/event-management/events": { component: Events },
		"/event-register-management/register": { component: EventElectionRegister },
		"/event-management/event-groups": { component: EventGroup },
		"/adjudication": { component: Adjudication },
		"/administration-reports": { component: AdministrationReports },
		"/reports/applications": {
			component: () => {
				return (
					<Reports
						reportType={{
							Name: "Application Reports",
							Type: "application"
						}}
					/>
				);
			}
		},
		"/reports/elector": {
			component: () => {
				return (
					<Reports
						reportType={{
							Name: "Elector Reports",
							Type: "elector"
						}}
					/>
				);
			}
		},
		"/reports/moha": {
			component: () => {
				return (
					<Reports
						reportType={{
							Name: "MOHA Reports",
							Type: "moha"
						}}
					/>
				);
			}
		},
		"/reports/moha_request": {
			component: () => {
				return (
					<Reports
						reportType={{
							Name: "MOHA Request Reports",
							Type: "moha_request"
						}}
					/>
				);
			}
		},
		"/reports/agegroup": {
			component: () => {
				return (
					<Reports
						reportType={{
							Name: "Age and Gender Group Reports",
							Type: "ageGroup"
						}}
					/>
				);
			}
		},
		"/reports/register": {
			component: () => {
				return (
					<Reports
						reportType={{
							Name: "Elector Register",
							Type: "registerReports"
						}}
						GenerateReportBtnTittle="Preview Register"
					/>
				);
			}
		},
		"/reports/ballot": {
			component: () => {
				return (
					<Reports
						reportType={{
							Name: "Ballot Paper Proof",
							Type: "ballots"
						}}
					/>
				);
			}
		},
		"/reports/candidatBallot": {
			component: () => {
				return (
					<Reports
						reportType={{
							Name: "Ballot Paper Proof",
							Type: "candidatBallot"
						}}
						InludeVillageOnSortConfig={false}
					/>
				);
			}
		},
		"/reports/politicalBallot": {
			component: () => {
				return (
					<Reports
						reportType={{
							Name: "Report",
							Type: "politicalBallot"
						}}
					/>
				);
			}
		},
		"/applications/search": { component: ApplicationSearch },
		"/applications/registrations": { component: Applications, applicationTypeID: APPLICATION_TYPE_REGISTRATION, screenType: "registration" },
		"/applications/migrations": { component: Applications, applicationTypeID: APPLICATION_TYPE_MIGRATION, screenType: "migration" },
		"/applications/transfers": { component: Applications, applicationTypeID: APPLICATION_TYPE_TRANSFER, screenType: "transfers" },
		"/applications/amendments": { component: Applications, applicationTypeID: APPLICATION_TYPE_AMENDMENT, screenType: "amendments" },
		"/applications/removals": { component: Applications, applicationTypeID: APPLICATION_TYPE_REMOVAL, screenType: "removals" },
		"/applications/suspensions": { component: Applications, applicationTypeID: APPLICATION_TYPE_SUSPENSION, screenType: "suspensions" },
		"/applications/reinstatements": { component: Applications, applicationTypeID: APPLICATION_TYPE_REINSTATEMENT, screenType: "re-instatements" },
		"/applications/corrections": { component: Applications, applicationTypeID: APPLICATION_TYPE_CORRECTION, screenType: "corrections" },

		"/applications/unassisted/registrations": {
			component: Applications,
			applicationTypeID: APPLICATION_TYPE_REGISTRATION,
			screenType: "unassisted-registration"
		},
		"/applications/unassisted/amendments": {
			component: Applications,
			applicationTypeID: APPLICATION_TYPE_AMENDMENT,
			screenType: "unassisted-amendments"
		},
		"/voters/search": { component: VoterAuditSearch },
		"/membership-periods": { component: ContestationPeriods }
	};

	var userRoutes = {};
	var modules = [];
	try {
		azureLoginState.groups.forEach((group) => {
			group.modules.forEach((mod) => {
				if (routes[mod.route]) {
					modules.push({ name: mod.route, group: mod.routeGroup });
					routes[mod.route].group = mod.routeGroup;
					routes[mod.route].action = mod.actions.map((action) => action.name);

					if (!routes[mod.route]?.subModules) {
						routes[mod.route].subModules = {};
					}
					var virtual_route_info = group.modules.filter((e) => e.route === `virtual:${[mod.route]}`);
					if (virtual_route_info) {
						virtual_route_info.forEach((e) => {
							var perm = e.actions.map((action) => action.name);
							var obj = { [e.routeGroup]: perm };
							routes[mod.route].subModules = { ...routes[mod.route].subModules, ...obj };
						});
					}
				}
			});
		});
	} catch (error) {}

	const menuHandler = (menu = [], allowedModules = []) => {
		return menu.reduce((filteredMenu, item) => {
			if (item.items) {
				// Recursively filter the nested items
				const filteredItems = menuHandler(item.items, allowedModules);
				if (filteredItems.length > 0) {
					filteredMenu.push({ ...item, items: filteredItems });
				}
			} else if (item.to && allowedModules.includes(item.to)) {
				// Only add the item if the 'to' path is in allowedModules
				filteredMenu.push(item);
				userRoutes[item.to] = routes[item.to];
			}
			return filteredMenu;
		}, []);
	};

	// var menu=JSON.parse(JSON.stringify())
	const allowedModules = modules.map((module) => module.name);
	const filteredMenu = menuHandler(menu, allowedModules);
	return { menu: filteredMenu, routes: userRoutes };
}
